<!-- Header da Pagina -->
<div class="page-header">
  <div class="header-icon">
    <i class="pi pi-user-plus"></i>
  </div>
  <div class="header-content">
    <h1 class="header-title">{{ 'contador.aprovacao.titulo_pagina' | translate }}</h1>
    <p class="header-subtitle">{{ 'contador.aprovacao.subtitulo_pagina' | translate }}</p>
  </div>
</div>

<div class="page-content">
  <app-aprovacao-solicitacoes></app-aprovacao-solicitacoes>
</div>
